import Code from "app/models/code"
import { Action, Types } from "./userAbsences.actions"

export type UserAbsence = {
  code: Code
  hours: number
  title: string
}

export type UserAbsencesState = {
  params: { year: string; uid: string }
  data: UserAbsence[]
  loading: boolean
  errors: object
}

const initialState: UserAbsencesState = {
  params: { year: "", uid: "" },
  data: [],
  loading: false,
  errors: {},
}

export default (state = initialState, action: Action): UserAbsencesState => {
  switch (action.type) {
    case Types.GET:
      return {
        ...state,
        params: action.payload.params,
        loading: true,
      }

    case Types.GET_SUCCESS:
      return {
        ...state,
        data: action.payload.data!,
        loading: false,
      }

    case Types.GET_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    default:
      return state
  }
}
